import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container city-point-config" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconOptions, (opt) => {
      return (_openBlock(), _createElementBlock("i", {
        class: _normalizeClass(["cpc-type-icon me-1 ms-1 primary-clickable text-center", opt.iconClass]),
        onClick: ($event: any) => (_ctx.setIcon(opt.value))
      }, null, 10, _hoisted_2))
    }), 256))
  ]))
}